"use client";

import { FC, useContext } from "react";
import {
	PAGESIZE_DEFAULT,
	PER_PAGE_VALUES,
} from "@/lib/searchspring/constants";
import { SearchSpringContext } from "@/components/SearchSpring/SearchSpringContext/SearchSpringContextProvider";
import SelectInput from "@/components/UI/Input/SelectInput/SelectInput";
import styles from "../../SortAndFilter.module.scss";

const PageSize: FC = () => {
	const { pageSize, setPageSize } = useContext(SearchSpringContext);

	const inputOptions = PER_PAGE_VALUES.map((value) => {
		return {
			text: String(value),
			value: String(value),
		};
	});

	const handleOnChange = (value: string) => {
		const numberValue = Number(value);
		setPageSize(numberValue === PAGESIZE_DEFAULT ? undefined : numberValue);
	};

	return (
		<SelectInput
			label={"Page size"}
			placeHolder='Items per page:'
			options={inputOptions}
			value={String(pageSize ? pageSize : PAGESIZE_DEFAULT)}
			prefix='Items per page: '
			onChange={handleOnChange}
			className={styles.field}
		/>
	);
};

export default PageSize;
